module.exports = __webpack_public_path__ + "img/dashboards-filters-projects.77d7282f.svg";